import { Reveal, SectionHeading } from "./shared";
import { useLanguage } from "@/i18n/LanguageContext";

export default function PlatformIntro() {
  const { t } = useLanguage();
  return (
    <section data-testid="platform-intro-section" className="px-6 py-5">
      <SectionHeading index="04" eyebrow="Partner" title={t("platformHeading")} testId="platform-intro-heading" />
      <Reveal>
        <div className="rounded-2xl border border-[rgba(22,99,230,0.14)] bg-white p-5 shadow-[0_10px_30px_-16px_rgba(11,61,145,0.3)]">
          <p className="text-sm leading-relaxed text-slate-600" data-testid="platform-intro-body">
            {t("platformBody1")}
          </p>
        </div>
      </Reveal>
    </section>
  );
}
